"use client";

import { useBranches } from "../lib/fetchBranches";
import { generateSlugWithId } from "../serverUtils";
import { PAGES_LINKS } from "../components/constants/navlink";

export const usePagesWithBranchQuery = () => {
    const { data: branches } = useBranches();
    const first = branches?.[0];

    // If no branches exist, filter out "Branch & Staff"
    if (!first) {
        return PAGES_LINKS.filter((link) => link.name !== "Branch & Staff");
    }

    const branchQuery = `?branch=${generateSlugWithId(first.id, first.branchName)}`;

    return PAGES_LINKS.map((link) =>
        link.name === "Branch & Staff"
            ? { ...link, url: `${link.url}${branchQuery}` }
            : link
    );
};
